export default __webpack_public_path__ + "static/media/desktop_posts_list.b171fa1f.png";